export const LoginOrSignupWithGoogleUrl =
  'https://auth.fruittful.com/oauth2/authorize?identity_provider=Google&redirect_uri=https://api.fruittful.com/v1/auth?app=frontend&response_type=CODE&client_id=3rmgcas9ltkq1dk53kub9imlnc&scope=email%20openid%20profile'

export const FruittfulDemoUrl =
  'https://www.fruittful.com/videos/fruittful-demo.mp4'

export const ChromeExtensionUrl =
  'https://chrome.google.com/webstore/detail/fruittful/okjodimnfecdjfncajhoeflgbogiibfo'
